import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import lodash from 'lodash';
import moment from 'moment';
import { Box } from '@material-ui/core';
import StudyUsersTeamTable from '../../../pages/studyOverview/containers/StudyUsers/StudyUsersTeamTable';
import fetchSentTasksByStatus from '../../actions/sentboxV4';
import { getDashboardDetailsBinderStudiesTasks } from '../../../overview/actions/dashboard';
import newInboxActions from '../../actions/newInbox';
import newInboxSelectors from '../../selectors/newInbox';
import { VIEWS } from '../../constants/newInbox';
import TaskWindowV4 from '../../components/NewInbox/Desktop/TaskWindowV4/TaskWindowV4';
import taskDetailActions from '../../actions/taskDetail';
import DocumentDetailView from '../../components/NewInbox/Common/DocumentDetailView/DocumentDetailView';
import { cancelDOATask } from '../../../forms/actions/doa';
import { cancelSdfaTask } from 'forms/actions/sdfa';
import {
    cancelEventSignature,
} from 'forms/actions/events';
const DEFAULT_FILTER = {
    search: '',
    filter: {},
    sort: { key: 'teamname', value: 'DESC' },
    initial: true,
};

export function SentTasks(props) {
    const styles = {
        centered: {
            display: 'flex',
            justifyContent: 'center',
        },
        myText: {
            fontFamily: 'Hind',
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '42px',
            letterSpacing: '0em',
            textAlign: 'left',
            width: '367px',
            height: '42px',
        },
        taskContainer: {
            height: '100%',
        },
        firstCol: {
            cursor: 'pointer',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    };

    const [filterRecord, setFilterRecord] = useState(DEFAULT_FILTER);
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [paginationdata, setPagination] = useState({
        limit: 25,
        offset: 0,
        totalCount: 0,
    });
    const [isZeroState, setIsZeroState] = useState(false);
    const [initialLoading, setInititalLoading] = useState(true);
    const [extendedTaskWindow, setExtendedTaskWindow] = useState(false);

    const getSentTasksRecords = async () => {
        setInititalLoading(true);
        await props.getDashboardDetailsBinderStudiesTasks(
            'name',
            'ASC',
            '',
            999999999,
            0
        );
        await props.fetchSentTasksByStatus(props.status, 'DESC', '', '', paginationdata.limit, paginationdata.offset);
        setInititalLoading(false);
    };

    useEffect(() => {
        getSentTasksRecords();
        return async () => {
            await props.setTaskForDetailDisplay({});
        };
    }, []);

    useEffect(() => {
        if (!initialLoading) {
            const names = props.userBinderStudiesNames.length > 0
                ? [
                    ...props.getSentTasksStudyBinderNames,
                    ...lodash.map(
                        props.userBinderStudiesNames,
                        (userBinderAndStudy) => userBinderAndStudy.name
                    )
                ]
                : props.getSentTasksStudyBinderNames;

            setColumns(
                buildSentTasksOpenColumns([...new Set(names)])
            );
        }
    }, [
        props.userBinderStudiesNames,
        props.getSentTasksStudyBinderNames,
        initialLoading,
        props.taskWindowDetail,
        props.userBinderAndStudy
    ]);

    useEffect(() => {
        if (!initialLoading) {
            if (!props.getSentTasksV4.length && filterRecord.initial) {
                setIsZeroState(true);
            } else {
                setIsZeroState(false);
            }
            setRows(buildSentTasksOpenRows(props.getSentTasksV4));
            setPagination({
                ...paginationdata,
                totalCount: props.getSentTasksCountV4,
            });
        }
    }, [
        props.getSentTasksV4,
        props.getSentTasksCountV4,
        initialLoading,
        props.taskWindowDetail,
    ]);

    useEffect(() => {
        if (
            !initialLoading &&
            props.shouldShowTaskWindowOnTaskLoad &&
            props.getSentTasksV4.length
        ) {
            let taskToShowOnTaskWindow = null;
            if (props.shouldShowTaskWindowOnTaskLoad == 'next')
                taskToShowOnTaskWindow = props.getSentTasksV4.find(
                    (s) => s.id == props.taskWindowDetail.nextTask
                );
            if (props.shouldShowTaskWindowOnTaskLoad == 'previous')
                taskToShowOnTaskWindow = props.getSentTasksV4.find(
                    (s) => s.id == props.taskWindowDetail.previousTask
                );

            if (taskToShowOnTaskWindow) {
                props.setTaskForDetailDisplay(taskToShowOnTaskWindow);
                props.setTaskWindowShowOnTaskLoad(false);
            }
        }
    }, [props.getSentTasksV4, initialLoading]);

    useEffect(() => {
        if (!lodash.isEmpty(props.taskWindowDetail)) {
            if (props.taskWindowDetail.typeName == 'task') {
                props.loadSdfaSentItemTaskDetail(
                    props.taskWindowDetail.id,
                    props.userHasPermission,
                    props.binderId
                );
            } else props.fetchTaskDetailByTask(props.taskWindowDetail);
        }
    }, [props.taskWindowDetail]);

    const buildSentTasksOpenRows = (tasks) => {
        return lodash.map(tasks, (task) => {
            let sentTaskRecipients;

            if (lodash.get(task, ['requestedFrom', 'displayName'])) {
                sentTaskRecipients = lodash.get(task, ['requestedFrom', 'displayName']);
            } else if (task.recipients && task.recipients.length > 0) {
                if (task.recipients.length === 1) {
                    sentTaskRecipients = task.recipients[0].displayName;
                } else {
                    sentTaskRecipients = `${task.recipients.length} Recipients`;
                }
            } else {
                sentTaskRecipients = 'Unknown';
            }

            return {
                sentTaskTitle: lodash.get(task, ['title']),
                sentTaskType: lodash.get(task, ['type']),
                sentTaskAction: lodash.get(task, ['actionName']),
                sentTaskBinder: lodash.get(task, ['binderName']),
                sentTaskSentTo: sentTaskRecipients,
                sentTaskSentDate: formatDateString(lodash.get(task, ['sentDate'])),
                sentTaskDueDate: formatDateString(lodash.get(task, ['dueDate'])),
                sentTaskCompletedDate: formatDateString(
                    lodash.get(task, ['completedDate'])
                ),
                taskDetailWindow: task,
            };
        });
    };

    const buildSentTasksOpenColumns = (uniqueBinderNames) => {
        const sentTaskColumns = [
            {
                title: 'Title',
                field: 'sentTaskTitle',
                searchPlaceholder: 'Title',
                hidden: false,
                headerStyle: {
                    width: '40%',
                    minWidth: '40%',
                },
                cellStyle: {
                    width: '40%',
                    color: 'var(--blue-500, #2057AD)',
                    maxWidth: 'none'
                },
                toolbarSearch: true,
                render: (rowData) => (
                    <Box>
                        <Box
                            style={styles.firstCol}
                            onClick={() =>
                                props.setTaskForDetailDisplay(rowData.taskDetailWindow)
                            }
                            title={rowData.sentTaskTitle}
                        >
                            {rowData.sentTaskTitle}
                        </Box>
                    </Box>
                ),
            },
            {
                title: 'Type',
                field: 'sentTaskType',
                searchPlaceholder: 'Type',
                hidden: !lodash.isEmpty(props.taskWindowDetail) ? true : false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0

                },
            },
            {
                title: 'Action',
                field: 'sentTaskAction',
                searchPlaceholder: 'Action',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0

                },
                toolbarSearch: true,
                toolbarFilter: 'multiList',
                toolbarFilterData: [
                    {
                        label: 'Approve and Sign',
                        key: 'approve_and_sign',
                    },
                    {
                        label: 'Review and Sign',
                        key: 'review_and_sign',
                    },
                    {
                        label: 'Train and Sign',
                        key: 'train_and_sign',
                    },
                    {
                        label: 'Certify and Sign',
                        key: 'certify_and_sign',
                    },
                    {
                        label: 'Read and Acknowledge',
                        key: 'read_and_acknowledge',
                    },
                ],
            },
            {
                title: 'Binder',
                field: 'sentTaskBinder',
                searchPlaceholder: 'Binder',
                hidden: false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0
                },
                toolbarFilter: 'multiSearchList',
                toolbarFilterData: uniqueBinderNames
                    .filter(item => item !== null && item !== '')
                    .sort((a, b) => a.localeCompare(b))
                    .map(item => ({
                        label: `${item}`,
                        key: `${item}`
                    }))
            },
            {
                title: 'Recipient',
                field: 'sentTaskSentTo',
                searchPlaceholder: 'Recipient',
                hidden: !lodash.isEmpty(props.taskWindowDetail) ? true : false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0

                },
                toolbarSearch: true,
            },
            {
                title: 'Sent Date',
                field: 'sentTaskSentDate',
                searchPlaceholder: 'Sent Date',
                hidden: !lodash.isEmpty(props.taskWindowDetail) ? true : false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0

                },
                ...(props.status === 'pending'
                    ? {
                        toolbarSort: 'DESC',
                        toolbarDefaultSort: true,
                        toolbarSortByPostFix: [' (Newest First)', ' (Oldest First)'],
                    }
                    : {}),
            },
            {
                title: 'Due Date',
                field: 'sentTaskDueDate',
                searchPlaceholder: 'Due Date',
                hidden: !lodash.isEmpty(props.taskWindowDetail) ? true : false,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0

                },
            },
            {
                title: 'Completed Date',
                field: 'sentTaskCompletedDate',
                searchPlaceholder: 'Completed Date',
                hidden:
                    props.status === 'complete'
                        ? !lodash.isEmpty(props.taskWindowDetail)
                            ? true
                            : false
                        : true,
                headerStyle: {
                    width: '10%',
                    minWidth: '10%',
                },
                cellStyle: {
                    width: '10%',
                    minWidth: '10%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: 0

                },
                ...(props.status === 'complete'
                    ? {
                        toolbarSort: 'DESC',
                        toolbarDefaultSort: true,
                        toolbarSortByPostFix: [' (Latest First)', ' (Earliest First)'],
                    }
                    : {}),
            },
        ];
        return sentTaskColumns;
    };

    const formatDateString = (dateString) => {
        if (dateString) {
            const date = moment.utc(dateString);
            const formattedDate = date.format('DD MMM YYYY');
            return formattedDate;
        } else {
            return null;
        }
    };

    const onFilterChange = async (
        filterRecords = filterRecord,
        pagination = paginationdata
    ) => {
        if (filterRecords && !filterRecords.initial) {
            setFilterRecord(filterRecords);
            let filters = filterRecords ? JSON.stringify(filterRecords.filter) : '';
            let sortOrder = filterRecords ? filterRecords.sort.value.toString() : '';
            let queryText = filterRecords ? filterRecords.search : '';
            props.fetchSentTasksByStatus(
                props.status,
                sortOrder,
                queryText,
                filters,
                pagination.limit,
                pagination.offset
            );
        }
    };
    const taskWindowNextPagination = async () => {
        await onFilterChange(filterRecord, {
            ...paginationdata,
            offset: paginationdata.offset + paginationdata.limit,
        });
        await props.setTaskWindowShowOnTaskLoad('next');
        setPagination({
            ...paginationdata,
            offset: paginationdata.offset + paginationdata.limit,
        });
    };
    const taskWindowPreviousPagination = () => {
        props.setTaskWindowShowOnTaskLoad('previous');
        onFilterChange(filterRecord, {
            ...paginationdata,
            offset: paginationdata.offset - paginationdata.limit,
        });
        setPagination({
            ...paginationdata,
            offset: paginationdata.offset - paginationdata.limit,
        });
    };

    const handleOnCancelTask = async (event) => {
        if (event.typeName == 'task') {
            let taskToCancel = event.cancelTaskId ? [event.cancelTaskId] : event.tasks.map(s => s.deleted ? null : s.id).filter(Boolean);
            await props.cancelSdfaTask(false, taskToCancel);
            if (event.cancelTaskId) {
                props.loadSdfaSentItemTaskDetail(
                    props.taskWindowDetail.id,
                    props.userHasPermission,
                    props.binderId
                );
                return false;
            }
        } else if (event.typeName === 'doa')
            await props.cancelDOATask(event.taskId, event.id);
        else if (event.typeName === 'event') {
            await props.cancelEventSignature(
                event.id,
                (event.event ? event.event.id : event.customEvent.id),
                (event.event ? event.event.institutionId : event.customEvent.institutionId)
            );
        }
        onFilterChange();
    };

    const showZeroStateForFilter = (
        (Object.values(filterRecord.filter).length > 0 || Object.values(filterRecord.search).length > 0) &&
        props.getSentTasksV4.length === 0
    );

    return !initialLoading &&
        props.getSentTasksV4.length === 0 &&
        !Object.values(filterRecord.filter).find((f) => f.length) &&
        isZeroState ? (
            <div style={styles.centered}>
                <p style={styles.myText}>
                    {props.status === 'pending'
                        ? 'You do not have any open sent tasks.'
                        : 'You do not have any completed sent tasks.'}
                </p>
            </div>
        ) : (
            <Fragment>
                <Box
                    display={
                        props.view === VIEWS.DOCUMENT_DETAIL ||
                        props.view === VIEWS.TASK_SIGNATURE
                            ? 'none'
                            : 'flex'
                    }
                    style={{ gap: extendedTaskWindow ? 0 : '20px', height: '100%' }}
                >
                    <Box
                        flex={1}
                        style={{
                            width: extendedTaskWindow ? '0' : '100%',
                            transition: 'all 0.3s ease',
                            opacity: extendedTaskWindow ? 0 : 1,
                            overflowY: 'auto',
                        }}
                    >
                        <StudyUsersTeamTable
                            rows={rows}
                            columns={columns}
                            pagination={paginationdata}
                            setPagination={setPagination}
                            setFilterRecord={setFilterRecord}
                            filterRecord={filterRecord}
                            onFilterUpdate={onFilterChange}
                            onChangePagination={(pagination) =>
                                onFilterChange(filterRecord, pagination)
                            }
                            footerLabel="tasks"
                            isLoadingTable={props.sentTasksFetching || initialLoading}
                            tableName="sent tasks"
                            showFilterPills={true}
                            highLightRow={props.taskWindowDetail.id}
                            showZeroStateForFilter={showZeroStateForFilter}
                        />
                    </Box>

                    {props.view !== VIEWS.DOCUMENT_DETAIL &&
                    !lodash.isEmpty(props.taskWindowDetail) && (
                        <Box
                            style={{
                                width: !lodash.isEmpty(props.taskWindowDetail)
                                    ? extendedTaskWindow
                                        ? '100%'
                                        : '600px'
                                    : '0px',
                                display: 'flex',
                                transition: 'all 0.3s ease',
                                overflow: 'hidden',
                                maxHeight: 'calc(100vh - 158.69px)',
                                position: 'relative',
                            }}
                        >
                            <TaskWindowV4
                                taskStatus={props.status}
                                extendedTaskWindow={extendedTaskWindow}
                                setExtendTaskWindow={() => {
                                    setExtendedTaskWindow(!extendedTaskWindow);
                                }}
                                paginateToNextPage={taskWindowNextPagination}
                                paginateToPreviousPage={taskWindowPreviousPagination}
                                paginationdata={paginationdata}
                                paginationTotal={paginationdata.totalCount}
                                isLoading={props.sentTasksFetching}
                                allowSignature={false}
                                showCancelButton={
                                    !lodash.isEmpty(props.taskWindowDetail) &&
                                        props.taskWindowDetail.tasks &&
                                        props.taskWindowDetail.tasks.filter(
                                            (s) => s.finished
                                        ).length > 0
                                        ? false
                                        : true
                                }
                                onCancelTask={handleOnCancelTask}
                                fromSentTask={true}
                                switchTaskLoading={props.switchTaskLoading}

                            />
                        </Box>
                    )}
                </Box>
                {props.view === VIEWS.DOCUMENT_DETAIL && (
                    <Box
                        style={{
                            display: props.view === VIEWS.DOCUMENT_DETAIL ? 'block' : 'none',
                        }}
                    >
                        <DocumentDetailView
                            changeView={props.changeView}
                            workflowId={props.taskWindowDetail.id}
                            isNewV4={true}
                        />
                    </Box>
                )}
            </Fragment>
        );
}

export default connect(
    (state) => {
        const getSentTasksV4 = lodash.get(state, 'sentTasks', []);
        const getSentTasksCountV4 = lodash.get(state, 'sentTasksCount', []);
        const getSentTasksStudyBinderNames = lodash.get(
            state,
            'sentTasksStudyBinderNames',
            []
        );
        const userBinderStudiesNames = lodash.get(
            state,
            'dashboard.binderStudiesTasks',
            []
        );
        const taskWindowDetail = newInboxSelectors.getTaskForDetailDisplay(state);

        return {
            getSentTasksV4,
            getSentTasksCountV4,
            getSentTasksStudyBinderNames,
            userBinderStudiesNames,
            sentTasksFetching: lodash.get(state, 'sentTasksFetching', false),
            taskWindowDetail,
            shouldShowTaskWindowOnTaskLoad: lodash.get(
                state,
                'shouldShowTaskWindowOnTaskLoad',
                false
            ),
            view: newInboxSelectors.getView(state),
            switchTaskLoading: lodash.get(state, 'taskDetailFetching', false)

        };
    },
    {
        fetchSentTasksByStatus,
        getDashboardDetailsBinderStudiesTasks,
        setTaskForDetailDisplay: newInboxActions.setTaskForDetailDisplay,
        setTaskWindowShowOnTaskLoad: newInboxActions.setTaskWindowShowOnTaskLoad,
        fetchTaskDetailByTask: taskDetailActions.fetchTaskDetail,
        changeView: newInboxActions.changeView,
        cancelDOATask,
        cancelSdfaTask,
        loadSdfaSentItemTaskDetail: taskDetailActions.loadSdfaSentItemTaskDetail,
        cancelEventSignature
    }
)(SentTasks);
